import { StatusMensagem } from './../enum/mensagem.enum';
export const ColorStatusMensagemEnvio = {
  [StatusMensagem.Programada]: 'blue',
  [StatusMensagem.Enviada]: 'green',
  [StatusMensagem.Gravada]: 'gold',
  [StatusMensagem['Não enviada']]: 'orange',
};
